module.exports = "https://static.cdns.space/tarot-temp/img/pc-banner.05eaf83e.png";